import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardImage,
  MatCardTitle,
} from '@angular/material/card';
import { NgClass, NgForOf, NgIf, NgOptimizedImage } from '@angular/common';
import { OpcaoMenu } from '../opcao-menu.interface';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-lateral-navegacao',
  standalone: true,
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    NgIf,
    NgOptimizedImage,
    MatCardImage,
    MatCardContent,
    RouterLink,
    NgForOf,
    NgClass,
  ],
  templateUrl: './lateral-navegacao.component.html',
  styleUrl: './lateral-navegacao.component.scss',
})
export class LateralNavegacaoComponent implements OnInit {
  @Input() titulo: string = '';
  @Input() caminho_imagem: string = '';

  @Input() ativos: OpcaoMenu[] = [];
  @Input() ativosCustomizados: boolean = false;

  @Input() inativos: OpcaoMenu[] = [];
  @Input() inativosCustomizados: boolean = false;

  @Input() cor_fundo_cabecalho: string = '#c42d27';

  @Output() qualFoiSelecionado = new EventEmitter<OpcaoMenu>();

  caminhoAtual = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.caminhoAtual = this.router.url.split('/')[1];
    this.caminhoAtual = '/' + this.caminhoAtual + '/';
  }

  selecionarMenu(opcao: OpcaoMenu): void {
    this.qualFoiSelecionado.emit(opcao);
  }
}
